function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M104.101 0H0.5V99.8847H104.101V0Z",
  fill: "white"
});

var _ref2 = /*#__PURE__*/React.createElement("g", {
  mask: "url(#mask0_11_2819)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M8.83008 32.8544C23.6501 14.9444 47.7501 9.85444 64.0201 21.7444C68.2301 24.8244 71.5201 28.7644 73.8701 33.2444C78.0801 23.7644 80.2301 13.7344 80.4201 3.70444C57.1401 -5.17556 29.9101 2.13444 14.5001 23.2144C12.2501 26.2944 10.3701 29.5244 8.83008 32.8544Z",
  fill: "#BBC4F6"
}), /*#__PURE__*/React.createElement("path", {
  d: "M57.7402 24.5144C49.0502 18.1644 36.0302 21.1744 28.4502 31.1844C28.3802 31.3544 28.3102 31.5144 28.2402 31.6744C31.4902 33.4544 34.8602 34.9044 38.3302 35.9944C44.1702 28.9444 53.6002 26.3744 61.9902 29.0144C60.8702 27.3044 59.4602 25.7744 57.7402 24.5144Z",
  fill: "#BBC4F6"
}), /*#__PURE__*/React.createElement("path", {
  d: "M93.7399 19.2544C101.85 41.0344 94.1999 64.4544 75.7699 72.6044C70.9899 74.7044 65.9399 75.5844 60.8799 75.3744C66.9799 83.7644 74.5999 90.6444 83.1899 95.8244C102.52 80.1044 109.81 52.8644 99.2599 28.9744C97.7099 25.4844 95.8499 22.2544 93.7399 19.2544Z",
  fill: "#6176EB"
}), /*#__PURE__*/React.createElement("path", {
  d: "M76.5002 65.7745C86.3502 61.4245 90.2502 48.6445 85.3602 37.0745C85.2502 36.9245 85.1502 36.7845 85.0402 36.6445C81.8702 38.5645 78.9302 40.7645 76.2502 43.2245C79.4402 51.8145 76.9502 61.2545 70.4702 67.1945C72.5202 67.0945 74.5602 66.6345 76.5002 65.7745Z",
  fill: "#6176EB"
}), /*#__PURE__*/React.createElement("path", {
  d: "M61.54 99.6445C38.62 95.7745 22.15 77.4345 24.32 57.4045C24.88 52.2145 26.65 47.3945 29.36 43.1145C19.05 44.2045 9.28 47.3645 0.5 52.2045C4.45 76.8145 24.4 96.7345 50.36 99.5445C54.15 99.9745 57.88 99.9845 61.54 99.6445Z",
  fill: "#1D3BE2"
}), /*#__PURE__*/React.createElement("path", {
  d: "M29.8601 61.4544C28.7101 72.1544 37.8201 81.9244 50.2901 83.4844C50.4801 83.4544 50.6501 83.4444 50.8201 83.4244C50.7401 79.7244 50.3101 76.0744 49.5201 72.5244C40.4901 70.9944 33.5501 64.1044 31.6501 55.5244C30.7101 57.3544 30.0901 59.3444 29.8601 61.4544Z",
  fill: "#1D3BE2"
}));

const SvgChidoriIcon = ({
  svgRef,
  title,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 106,
  height: 100,
  viewBox: "0 0 106 100",
  fill: "none",
  ref: svgRef
}, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, /*#__PURE__*/React.createElement("mask", {
  id: "mask0_11_2819",
  style: {
    maskType: "luminance"
  },
  maskUnits: "userSpaceOnUse",
  x: 0,
  y: 0,
  width: 105,
  height: 100
}, _ref), _ref2);

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgChidoriIcon, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/chidori-icon.1c5b88b5.svg";
export { ForwardRef as ReactComponent };